import { z } from "zod";
import { api } from "@/lib/api";

const refreshSourceSchema = z.object({
  status: z.enum(["queued", "busy", "unavailable", "failed"]),
  errorCode: z.string().optional(),
});
const refreshResponseSchema = z.object({
  success: z.literal(true),
  data: z.object({
    results: z.array(
      z.object({
        shopId: z.string().uuid(),
        storeInformation: refreshSourceSchema,
        catalog: refreshSourceSchema,
        advertising: refreshSourceSchema,
        sales: refreshSourceSchema,
      }),
    ),
  }),
});

export async function refreshWorkspaceShopData(workspaceId: string, shopId: string) {
  const response = await api
    .post("sync/data-refresh", { json: { workspaceId, shopIds: [shopId] } })
    .json();
  return refreshResponseSchema.parse(response).data;
}
